import ReactPixel from "react-facebook-pixel";

export const initFacebookPixel = () => {
  ReactPixel.init("YOUR_PIXEL_ID", undefined, {
    autoConfig: true,
    debug: false,
  });

  ReactPixel.pageView(); // Track page view
};

export const trackCustomEvent = (eventName, data = {}) => {
  ReactPixel.track(eventName, data);
};
